export default "__VITE_ASSET__9f056376__"